import { UNIT_CODE_LENGTH } from './constants';

export const SHELF_LOCATION_MAX_LENGTH = 6;

export const normalizeShelfLocation = (value) =>
  (value || '')
    ?.toUpperCase()
    ?.replace(/[^A-Z0-9]/g, '')
    ?.slice(0, SHELF_LOCATION_MAX_LENGTH);

export const buildPiecesInput = (contents, counts) =>
  (contents || [])?.map((content) => {
    const countPresent = Number(counts?.[content?.contentId || content?.name]);
    return {
      ...(content?.contentId
        ? { contentId: content?.contentId }
        : { name: content?.name }),
      countPresent: Number.isFinite(countPresent) ? countPresent : 0,
    };
  });

export const buildChecklistAnswersInput = (checklist, answers) =>
  (checklist || [])
    ?.filter((item) => {
      const value = answers?.[item?.id || item?.text];
      return value !== undefined && value !== null;
    })
    ?.map((item) => ({
      ...(item?.id ? { checklistItemId: item?.id } : { text: item?.text }),
      value: answers?.[item?.id || item?.text],
    }));

export const getContentKey = (content) => content?.contentId || content?.name;

export const getChecklistKey = (item) => item?.id || item?.text;

export const normalizeUnitCode = (value) =>
  (value || '')
    ?.toUpperCase()
    ?.replace(/[^A-Z0-9]/g, '')
    ?.slice(0, UNIT_CODE_LENGTH);

export const isCompleteUnitCode = (value) =>
  normalizeUnitCode(value)?.length === UNIT_CODE_LENGTH;

export const buildClientRequestId = (prefix, code) =>
  `web-${prefix}-${Date.now()}-${code || 'unit'}`;

export const isPieceShort = (content, counts) => {
  const key = getContentKey(content);
  const count = Number(counts?.[key]);
  const minimum = content?.minimumQuantity;
  if (!Number.isFinite(count) || minimum === null || minimum === undefined) {
    return false;
  }
  return count < minimum;
};

export const isChecklistAnswerFailing = (item, answers) => {
  const value = answers?.[getChecklistKey(item)];
  const { expected } = item || {};
  if (expected === null || expected === undefined) return false;
  if (value === undefined || value === null) return false;
  if (Array.isArray(expected)) return !expected?.includes(value);
  return expected !== value;
};

export const REQUIRED_FIELD_MESSAGE = 'This field is required';

export const hasPieceCount = (value) =>
  value !== undefined && value !== null && value !== '';

export const getInspectionErrors = (inspectionForm, counts, answers) => {
  const errors = {};
  (inspectionForm?.requiredContents || [])?.forEach((content) => {
    const key = getContentKey(content);
    if (!hasPieceCount(counts?.[key])) {
      errors[key] = REQUIRED_FIELD_MESSAGE;
    }
  });
  (inspectionForm?.checklist || [])?.forEach((item) => {
    const key = getChecklistKey(item);
    const answer = answers?.[key];
    if (answer === undefined || answer === null) {
      errors[key] = REQUIRED_FIELD_MESSAGE;
    }
  });
  return errors;
};

export const isInspectionDamaged = (inspectionForm, counts, answers) => {
  const shortPiece = (inspectionForm?.requiredContents || [])?.some((content) =>
    isPieceShort(content, counts),
  );
  const failedBlocking = (inspectionForm?.checklist || [])?.some(
    (item) => item?.isBlocking && isChecklistAnswerFailing(item, answers),
  );
  return Boolean(shortPiece || failedBlocking);
};

export const NOT_DAMAGED_CONTENT_MESSAGE = 'All required pieces are present';
export const NOT_DAMAGED_CHECKLIST_MESSAGE = "This answer doesn't indicate any damage";

export const getNotDamagedErrors = (inspectionForm, counts, answers) => {
  const errors = {};
  (inspectionForm?.requiredContents || [])?.forEach((content) => {
    if (!isPieceShort(content, counts)) {
      errors[getContentKey(content)] = NOT_DAMAGED_CONTENT_MESSAGE;
    }
  });
  (inspectionForm?.checklist || [])?.forEach((item) => {
    if (
      item?.isBlocking &&
      item?.expected !== null &&
      item?.expected !== undefined &&
      !isChecklistAnswerFailing(item, answers)
    ) {
      errors[getChecklistKey(item)] = NOT_DAMAGED_CHECKLIST_MESSAGE;
    }
  });
  return errors;
};
